import httpClient from '../httpClient';

// 영업사원(Employee) 전용 API

export const getAssignedCustomers = async (filters = {}) => {
  const result = await httpClient.get('/rep/assigned-customers', {
    params: filters,
  });
  return result.data;
};

export const impersonateCustomer = async (targetUserId) => {
  const result = await httpClient.post('/rep/impersonate', { targetUserId });
  return result.data;
};

export const sendWelcomeMessage = async (targetUserId) => {
  const result = await httpClient.post('/rep/send-welcome', { targetUserId });
  return result.data;
};
